import { gql } from '@apollo/client';
import {
    BASIC_FILE_FIELDS_FRAGMENT,
    BASIC_FILE_TYPE_FIELDS_FRAGMENT,
    FR_ENTITY_DOC_RESOURCE_FIELDS
} from './fragments/file';
import { FOLDERS_FRAGMENT } from './fragments/folder';

export const GET_FILE_TEMPLINK = gql`
    query fileTempLink($FileId: Int!) {
        fileTempLink(data: { FileId: $FileId })
    }
`;

export const GET_FILE = gql`
    query file($FileId: Int!) {
        file(data: { FileId: $FileId }) {
            ...BasicFileFields
        }
    }
    ${BASIC_FILE_FIELDS_FRAGMENT}
`;

export const GET_ENTITYFILES = gql`
    query entityFiles($FileTypeName: FileTypeEnum!, $EntityId: Int!) {
        entityFiles(data: { EntityId: $EntityId, FileTypeName: $FileTypeName }) {
            ...FolderFields
        }
    }
    ${FOLDERS_FRAGMENT}
`;

export const UPLOAD_ENTITYFILES = gql`
    mutation uploadEntityFile(
        $File: Upload!
        $EntityId: Int!
        $FileTypeName: FileTypeEnum!
        $FolderId: Int
        $Vendor: String
        $CalibrationDate: Date
        $ExpirationDate: Date
    ) {
        uploadEntityFile(
            data: {
                File: $File
                EntityId: $EntityId
                FileTypeName: $FileTypeName
                Vendor: $Vendor
                CalibrationDate: $CalibrationDate
                ExpirationDate: $ExpirationDate
                FolderId: $FolderId
            }
        ) {
            ...FolderFields
        }
    }
    ${FOLDERS_FRAGMENT}
`;

export const DELETE_ENTITYFILE = gql`
    mutation deleteEntityFile($FileId: Int!, $EntityId: Int!) {
        deleteEntityFile(data: { FileId: $FileId, EntityId: $EntityId }) {
            ...FolderFields
        }
    }
    ${FOLDERS_FRAGMENT}
`;

export const FILE_TYPES = gql`
    query fileTypes {
        fileType {
            ...BasicFileTypeFields
        }
    }
    ${BASIC_FILE_TYPE_FIELDS_FRAGMENT}
`;

export const UPDATE_FILE = gql`
    mutation updateFile(
        $FileId: Int!
        $FileTypeName: FileTypeEnum!
        $FileName: String
        $Vendor: String
        $CalibrationDate: Date
        $ExpirationDate: Date
    ) {
        updateFile(
            data: {
                FileId: $FileId
                FileTypeName: $FileTypeName
                FileName: $FileName
                Vendor: $Vendor
                CalibrationDate: $CalibrationDate
                ExpirationDate: $ExpirationDate
            }
        ) {
            ...FolderFields
        }
    }
    ${FOLDERS_FRAGMENT}
`;

export const GET_ENTITY_DOC_RESOURCE = gql`
    query getEntityDocResource($EntityId: Int!, $EntityType: FileTypeEnum!, $FolderId: Int) {
        entityDocResource(
            data: { EntityId: $EntityId, EntityType: $EntityType, FolderId: $FolderId }
        ) {
            ...fr_EntityDocResourceFields
        }
    }
    ${FR_ENTITY_DOC_RESOURCE_FIELDS}
`;

export const UPLOAD_ENTITY_DOC_RESOURCE = gql`
    mutation uploadEntityDocResource(
        $File: Upload!
        $EntityId: Int!
        $FileTypeName: FileTypeEnum!
        $FolderId: Int
        $Vendor: String
        $CalibrationDate: Date
        $ExpirationDate: Date
    ) {
        uploadEntityDocResource(
            data: {
                File: $File
                EntityId: $EntityId
                FileTypeName: $FileTypeName
                Vendor: $Vendor
                CalibrationDate: $CalibrationDate
                ExpirationDate: $ExpirationDate
                FolderId: $FolderId
            }
        ) {
            ...fr_EntityDocResourceFields
        }
    }
    ${FR_ENTITY_DOC_RESOURCE_FIELDS}
`;

export const DELETE_ENTITY_DOC_RESOURCE = gql`
    mutation deleteEntityResourceDoc($FileId: Int!, $EntityId: Int!) {
        deleteEntityResourceDoc(data: { FileId: $FileId, EntityId: $EntityId }) {
            ...fr_EntityDocResourceFields
        }
    }
    ${FR_ENTITY_DOC_RESOURCE_FIELDS}
`;

export const UPDATE_MACHINE_CALIBRATION_DOC_RESOURCE = gql`
    mutation updateMachineCalibrationDocResource(
        $MachineId: Int!
        $FileId: Int!
        $CalibrationDate: DateTime
        $ExpirationDate: DateTime
        $Vendor: String
    ) {
        updateMachineCalibration(
            data: {
                MachineId: $MachineId
                FileId: $FileId
                CalibrationDate: $CalibrationDate
                ExpirationDate: $ExpirationDate
                Vendor: $Vendor
            }
        ) {
            ...fr_EntityDocResourceFields
        }
    }
    ${FR_ENTITY_DOC_RESOURCE_FIELDS}
`;

export const UPDATE_EQUIPMENT_CALIBRATION_DOC_RESOURCE = gql`
    mutation updateEquipmentCalibrationDocResource(
        $EquipmentId: Int!
        $FileId: Int!
        $CalibrationDate: DateTime
        $ExpirationDate: DateTime
        $Vendor: String
    ) {
        updateEquipmentCalibration(
            data: {
                EquipmentId: $EquipmentId
                FileId: $FileId
                CalibrationDate: $CalibrationDate
                ExpirationDate: $ExpirationDate
                Vendor: $Vendor
            }
        ) {
            ...fr_EntityDocResourceFields
        }
    }
    ${FR_ENTITY_DOC_RESOURCE_FIELDS}
`;
